import axios from 'axios';
import { API } from "aws-amplify";
import TokenService from './storage.service';

const ApiService = {
  init(baseURL) {
    axios.defaults.baseURL = baseURL;
  },

  setHeader() {
    axios.defaults.headers.common['Authorization'] = `Bearer ${TokenService.getToken("idToken")}`;
  },

  removeHeader() {
    axios.defaults.header.common = {};
  },

  get(resource) {
    return API.get('multicloud', resource)
  },

  post(resource, data) {
    return API.post('multicloud', resource, { body: data });
  },

  put(resource, data) {
    return API.put('multicloud', resource, { body: data });
  },

  delete(resource) {
    return API.del('multicloud', resource)
  },


  // data
  // - method
  // - url
  // - data
  // - auth (optional) username/password
  customResource(data) {
    return axios(data);
  }
}

export default ApiService;